import { AxiosError, AxiosResponse } from 'axios';
import qs from 'qs-stringify';

import { RESPONSE_CODES } from '../constants/responseCodes.constants';
import { PaginationFactory, PaginatorFactory } from '../factory';
import { api } from '../http';
import { store } from '../store';
import { DefaultRes, ReportTypes, RiskReportTypes } from '../types';

// reportType should be more specific than just 'string'

export class ReportService {
    public static readonly dispatch = store.dispatch.report;
    public static readonly state = store.getState();

    public static async fetchMany(
        dto: PaginatorFactory<{}>,
        callback?: (isValid?: boolean, message?: string) => void,
        ignoreState = false,
    ): Promise<PaginationFactory<ReportTypes.Model> | void> {
        const {
            dispatch: { toggleLoading, setPagination },
        } = ReportService;

        try {
            if (!ignoreState) {
                toggleLoading('fetchMany', true);
            }
            
            const qsfy = qs({
                perPage: dto.perPage,
                page: dto?.page,
                filter: {
                    ...dto?.filter,
                },
            });

            let {
                data: {
                    result: { items, page, perPage, total },
                    isValid,
                    message,
                },
            } = await api.get<
                DefaultRes<PaginationFactory<ReportTypes.Model>>,
                AxiosResponse<DefaultRes<PaginationFactory<ReportTypes.Model>>>
            >(`/reports/getMany?${qsfy}`);

            if (!ignoreState) {
                toggleLoading('fetchMany', false);

                if (isValid) {
                    setPagination({ items, page, perPage, total });
                }
            }

            callback && callback(isValid, RESPONSE_CODES[message]);

            return { items, page, perPage, total };
        } catch (error: any) {
            toggleLoading('fetchMany', false);
            if (error.response) {
                const ERROR_CODE = (
                    error as AxiosError<DefaultRes<ReportTypes.Model>>
                ).response?.data?.message;

                callback && callback(false, RESPONSE_CODES[ERROR_CODE!]);
            }
            callback && callback(false, String(error));
        }
    }

    public static async destroy(
        ids: Array<string>,
        callback?: (isValid?: boolean, message?: string) => void
    ) {
        const {
            dispatch: { toggleLoading, destroyReport },
        } = ReportService;

        try {
            toggleLoading('delete', true);

            const {
                data: { isValid, message },
            } = await api.post<
                DefaultRes<ReportTypes.Model>,
                AxiosResponse<DefaultRes<ReportTypes.Model>>
            >(`/reports/destroy`, { ids });

            toggleLoading('delete', false);

            //destroyReport(id);

            return callback && callback(isValid, RESPONSE_CODES[message]);
        } catch (error: any) {
            toggleLoading('delete', false);
            if (error.response) {
                const ERROR_CODE = (
                    error as AxiosError<DefaultRes<ReportTypes.Model>>
                ).response?.data?.message;

                return callback && callback(false, RESPONSE_CODES[ERROR_CODE!]);
            }
            return callback && callback(false, String(error));
        }
    }


    public static async generateRiskReport(
        requestObject: RiskReportTypes.RiskAssessmentRequest,
        setLoading: (loading: boolean) => void,
        setReport: (report: RiskReportTypes.RiskResponse | null) => void,
        setCurrentView : (view: 'search' | 'details') => void,
        showErrorToast : ()=> void
    ) {
        try {
            setLoading(true);
            const {data} = await api.post<
                RiskReportTypes.RiskResponse,
                AxiosResponse<RiskReportTypes.RiskResponse>
            >(`/proxy/external/intakeRiskAssessment`, requestObject);
            setReport(data as RiskReportTypes.RiskResponse);
            setCurrentView('details')
        } catch (error: any) {
            console.log("Error generating risk report:", error);
            setReport(null);
            showErrorToast();
        }
        finally {
            setLoading(false)
        }
    }
}
